import { render, staticRenderFns } from "./PomoFocus.vue?vue&type=template&id=2300d3ff"
import script from "./PomoFocus.vue?vue&type=script&lang=ts"
export * from "./PomoFocus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports